import axios from "axios";
import { API_BASE_URL } from "../../config/api";

const superAdminAxiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Request Interceptor: Super admin token'ı otomatik ekler
superAdminAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("superAdminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Token süresi dolarsa super admin login'e yönlendir
superAdminAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("superAdminToken");
      localStorage.removeItem("superAdminUser");
      window.location.href = "/super-admin/auth/secure-access/login";
    }
    return Promise.reject(error);
  }
);

export default superAdminAxiosInstance;

